import React, { useState } from "react";
import { GridColDef, GridRowId } from "@mui/x-data-grid-pro";
import { MUIBackendTable } from "./PaginatedDataTable";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { ColumnStack } from "./Stacks";
import useAuth from "hooks/useAuth";



type PresubmissionDataTableProps = {
    jsonKey: string;
    columns: GridColDef[];
    queryString: string;
    setSelected: (arg0: number[]) => void;
    selected: GridRowId[];
    refresh: boolean;
}

export default function PresubmissionDataTable({ jsonKey, columns, queryString, setSelected, refresh, selected, ...props }: PresubmissionDataTableProps) {
    const { user }: { user: any } = useAuth();
    const isBiller = ["Biller", "Admin"].includes(user?.Type)

    const [filter, setFilter] = useState<"all" | "sbs" | "client">(isBiller ? "all" : "client")

    switch (filter) {
        case "all":
            // we do this to trigger a render
            queryString += " "
            break
        case "sbs":
            queryString += "&assignedToClient=false"
            break
        case "client":
            queryString += "&assignedToClient=true"
            break
    }

    return (
        <ColumnStack height="100%">
            <RadioGroup
                value={filter}
                onChange={(_, value) => setFilter(value as "all" | "sbs" | "client")}
                row
            >
                <FormControlLabel
                    value={"all"}
                    label="All"
                    control={<Radio />}
                />
                <FormControlLabel
                    value={"sbs"}
                    label="SBS"
                    control={<Radio />}
                />
                <FormControlLabel
                    value={"client"}
                    label="Client"
                    control={<Radio />}
                />
            </RadioGroup>
            <MUIBackendTable
                jsonKey={jsonKey}
                columns={columns}
                queryString={queryString}
                selected={selected}
                setSelected={setSelected}
                refresh={refresh}
                {...props}
            />
        </ColumnStack>
    )
}
